export const areElementsInArray = (
  array: unknown[] | null | undefined,
): boolean => !!(array && array.length);
